/**
 * API client for authentication REST API
 */
import { API_BASE } from '../constants';
import BaseAPI from '../../../../resources/scripts/components/BaseAPI';

class AuthAPI extends BaseAPI {
  constructor(baseUrl = null) {
    super(baseUrl || API_BASE, null, 'POST');
  }

  /**
   * Check if email exists
   */
  async checkEmail(email) {
    return this.request('/check-email', {
      body: JSON.stringify({ email }),
    });
  }

  /**
   * User login
   */
  async login(email, password) {
    return this.request('/login', {
      body: JSON.stringify({ email, password }),
    });
  }

  /**
   * User registration
   */
  async register(formData) {
    return this.request('/register', {
      body: JSON.stringify(formData),
    });
  }

  /**
   * Password reset request
   */
  async resetPassword(email, authPageUrl) {
    return this.request('/reset-password', {
      body: JSON.stringify({
        email,
        auth_page_url: authPageUrl,
      }),
    });
  }

  /**
   * Validate password reset key
   */
  async validateResetKey(key, login) {
    return this.request('/validate-reset-key', {
      body: JSON.stringify({ key, login }),
    });
  }

  /**
   * Change password
   */
  async changePassword(key, login, password, passwordConfirm) {
    return this.request('/change-password', {
      body: JSON.stringify({
        key,
        login,
        password,
        password_confirm: passwordConfirm,
      }),
    });
  }

  /**
   * Validate email verification key
   */
  async validateVerificationKey(key, login) {
    return this.request('/validate-verification-key', {
      body: JSON.stringify({ key, login }),
    });
  }

  /**
   * Verify email
   */
  async verifyEmail(key, login) {
    return this.request('/verify-email', {
      body: JSON.stringify({ key, login }),
    });
  }

  /**
   * Resend verification link
   */
  async resendVerification(email, authPageUrl) {
    return this.request('/resend-verification', {
      body: JSON.stringify({
        email,
        auth_page_url: authPageUrl,
      }),
    });
  }

  /**
   * Handle SSO callback
   */
  async ssoCallback(code, state, redirectUri) {
    return this.request('/sso/callback', {
      body: JSON.stringify({
        code,
        state,
        redirect_uri: redirectUri,
      }),
    });
  }

  /**
   * Complete SSO registration
   */
  async ssoCompleteRegistration(ssoToken, formData) {
    return this.request('/sso/complete-registration', {
      body: JSON.stringify({
        sso_token: ssoToken,
        ...formData,
      }),
    });
  }
}

export default AuthAPI;
